/* eslint-disable no-unused-vars */
import React,{useState} from "react";
import { Link } from "react-router-dom";
import { useFirebase } from "react-redux-firebase";
import { useSelector } from "react-redux";
import {Nav,
  NavContainer,
  NavStart,
  NavHeading,
  NavEnd,
  NavMenu,
  GitHub,
  GitHeader,
  SideNav,
  NavLinks,
  AboutLink,
  NavLogo,
  Hamburger,
  Burger,
  SideNavLink,
  SideNavLogo,
  GithubButton,
  SideNavGit,
  SideNavMenu,
Button} from '../../styles/Navbar-Styles.js';

const UserNavbar = (props) => {
  return (
      <div></div>
  );
};

const AdminNavbar = () => {
  const firebase = useFirebase();
  return (
    <Button onClick={() => firebase.logout()}>LogOut</Button>
  );
};

const Navbar = () => {
const [open, setOpen] = useState(false);

const toggle = (e) =>{
  setOpen(!open);

}

  const firebaseReducer = useSelector((state) => state.firebase);
  const { auth } = firebaseReducer;
  return (
    <Nav>

        <SideNav open={open} onClick={toggle}>
        <Link to="/"><SideNavLogo src={require('../../assets/gradient.svg').default}/></Link>
        <Link to="/about"><SideNavLink>About</SideNavLink></Link>
        <Link to="/contact"><SideNavLink>Contact</SideNavLink></Link>
                <a href="http://www.github.com/swapnilr17">
                <GithubButton>
                  <SideNavGit src={require(`../../assets/github.svg`).default} /> Github
                </GithubButton>
                </a>
                <SideNavMenu>
                {!auth.isEmpty ? <AdminNavbar /> : null}
            </SideNavMenu>

        </SideNav>
        <NavContainer>
          <NavStart>
            <Link to="/">
              <NavHeading>
                <div><NavLogo src={require('../../assets/gradient.svg').default}/></div>
              <NavLinks>
              <Link to="/about"><AboutLink>About</AboutLink></Link>
              <Link to="/contact"><AboutLink>Contact</AboutLink></Link>
              </NavLinks>
              </NavHeading>
            </Link>
          </NavStart>
          <NavEnd>
            <GitHeader>
                <a href="http://www.github.com/swapnilr17">
                  <GitHub src={require(`../../assets/github.svg`).default} width="40px"/>
                </a>
                </GitHeader>
                <Hamburger onClick={(e)=>toggle()}>
                  <Burger/>
                  <Burger/>
                  <Burger/>
                </Hamburger>
            <NavMenu>
                {!auth.isEmpty ? <AdminNavbar /> : null}
            </NavMenu>
          </NavEnd>
        </NavContainer>
    </Nav>
  );
};

export default Navbar;